import React from 'react';
import MuchWorse from '../svg/MuchWorse';
import Same from '../svg/Same';
import MuchBetter from '../svg/MuchBetter';
import { decrypt } from '../utils/crypto';
import { useTranslation } from 'react-i18next';
import { camelCase } from 'lodash';
import i18n from '../i18n';

const mood = {
	Worse: <MuchWorse />,
	'Much worse': <MuchWorse />,
	Same: <Same />,
	Better: <MuchBetter />,
	'Much better': <MuchBetter />,
};

const moodQuestions = {
	Worse: 'sorryToHearThatThingsAreWorseWhichOfTheFollowingWouldHelpRightNow',
	'Much worse': 'feelingMuchWorseQuestion',
	Same: 'feelingSameQuestion',
	Better: 'feelingBetterQuestion',
	'Much better': 'greatToHearThingsAreMuchBetterAndThinkAboutHowToImproveEvenMoreOrKeepItOnAPositiveLevel',
};

export default function CompareNote({ note }) {
	const secretKey = localStorage.getItem('secret_key');
	const { t } = useTranslation();
	return (
		<div className='compare-note-container'>
			<div className='note-compare-one'>
				<div className='v-center-flex'>
					<div className='note-question'>
						<span>{t('doYouThinkThingsAreForAnyReasonInParticular', { result: t(camelCase(note.compare)).toLowerCase() })}</span>
					</div>
					<div style={{ transform: i18n.language === 'ar' ? 'scaleX(-1)' : 'none' }}>
						<span>{mood[note.compare]}</span>
					</div>
				</div>
				<div className='note-textarea'>
					<span>{decrypt(note.message, secretKey)}</span>
				</div>
			</div>
			<div className='note-compare-two'>
				<div className='note-question'>
					<span>{t(moodQuestions[note.compare])}</span>
				</div>
				<div className='note-suggestions'>
					{note.suggestions.map((suggestion, index) => {
						return (
							<div className='v-center-flex' key={index}>
								<div className='note-suggestion-number'>
									<span>{index + 1}.</span>
								</div>
								<div className='note-suggestion'>{decrypt(suggestion, secretKey)}</div>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
}
